// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3yePP","icon":"style_icon__1Tl_S"};